// ============================================================
//  EDIT YOUR DETAILS HERE — everything on the page reads from
//  this file, so you can update it without touching the design.
// ============================================================
export const profile = {
  name: "Joseph Scott",
  title: "Founder & Chief Executive Officer",
  company: "Hithlain Technologies",
  tagline: "Building the future of drone defense.",
  bio: "Joseph Scott is the Founder and Lead Researcher of Hithlain Technologies. Hithlain Technologies aims to build affordable kinetic drone defense for every platform. We believe the future of defense belongs to affordable, easily deployed systems warfighters can deploy in seconds, trust under electronic attack, and lose without losing the mission. From counter-threat overwatch to hardened autonomous platforms, we design for the realities of the modern battlefield: contested spectrum, dispersed units, and budgets that demand more capability per dollar. Built by people who've served, for the people still out there.",
  portrait:
    "https://customer-assets.emergentagent.com/job_contact-hub-387/artifacts/hohlxqav_picture%20for%20landing%20page2.jpg",
  contact: {
    email: "Joe98paul@gmail.com",
    phone: "(985) 355-9092",
    location: "Hammond, LA",
  },
  socials: [
    { label: "LinkedIn", handle: "in/joseph-scott", url: "https://www.linkedin.com/in/joseph-scott-4437b7167" },
    { label: "Instagram", handle: "@jpscottt98", url: "https://www.instagram.com/jpscottt98/" },
    { label: "Facebook", handle: "joseph.scott", url: "https://www.facebook.com/joseph.scott.245861/" },
    { label: "Website", handle: "Website Coming Soon", url: null },
  ],
  // Highlights shown as small "stat" chips
  highlights: [
    { value: "12+", label: "Years Operating" },
    { value: "$40M", label: "Capital Raised" },
    { value: "3", label: "Exits" },
  ],
};
